export default "__VITE_PUBLIC_ASSET__8fe7cc56__"